import styles from './ConditionStrip.module.css';

const conditions: Array<{ key: string; label: string; varName: string }> = [
  { key: 'mint',    label: 'Near mint', varName: '--color-condition-mint' },
  { key: 'vgood',   label: 'Very good', varName: '--color-condition-vgood' },
  { key: 'good',    label: 'Good',      varName: '--color-condition-good' },
  { key: 'fair',    label: 'Fair',      varName: '--color-condition-fair' },
  { key: 'poor',    label: 'Poor',      varName: '--color-condition-poor' },
  { key: 'damaged', label: 'Damaged',   varName: '--color-condition-damaged' },
];

export default function ConditionStrip() {
  return (
    <div className={styles.strip} aria-hidden="true">
      {conditions.map((c) => (
        <div
          key={c.key}
          className={styles.cell}
          style={{ background: `var(${c.varName})` }}
        >
          {c.label}
        </div>
      ))}
    </div>
  );
}
